// src/components/ChatWidget.jsx
import React, { useState } from "react";

const ChatWidget = ({
  isOpen,
  onClose,
  messages = [],
  onSend,
  isSending = false,
}) => {
  const [input, setInput] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed) return;

    setInput("");

    if (onSend) {
      await onSend(trimmed);
    }
  };

  return (
    <div className="fixed bottom-20 right-4 z-[9998] w-[320px] max-w-[90vw] rounded-2xl border border-slate-200 bg-white shadow-2xl shadow-slate-900/20">
      {/* Header */}
      <div className="flex items-center justify-between rounded-t-2xl bg-gradient-to-r from-amber-300 via-amber-400 to-teal-500 px-3 py-2 text-xs text-slate-900">
        <div className="flex items-center gap-2">
          <div className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-[11px] font-bold text-teal-600">
            Z
          </div>
          <div className="flex flex-col">
            <span className="font-semibold">ZiiHub Assistant</span>
            <span className="text-[10px] text-slate-800/80">
              Powered by GPT-5.1
            </span>
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="rounded-full bg-white/80 px-2 text-[11px] font-semibold text-slate-700 hover:bg-white"
        >
          ✕
        </button>
      </div>

      {/* Messages */}
      <div className="flex max-h-80 flex-col gap-2 overflow-y-auto bg-slate-50 px-3 py-3 text-[12px]">
        {messages.map((m) => (
          <div
            key={m.id}
            className={`flex ${
              m.from === "user" ? "justify-end" : "justify-start"
            }`}
          >
            <div
              className={`max-w-[80%] rounded-2xl px-3 py-2 ${
                m.from === "user"
                  ? "bg-teal-600 text-white"
                  : "bg-white text-slate-800 border border-slate-200"
              }`}
            >
              {m.text}
            </div>
          </div>
        ))}

        {isSending && (
          <div className="flex justify-start">
            <div className="max-w-[80%] rounded-2xl bg-white text-slate-500 border border-slate-200 px-3 py-2 italic">
              Typing…
            </div>
          </div>
        )}
      </div>

      {/* Input */}
      <form
        onSubmit={handleSubmit}
        className="flex items-center gap-2 border-t border-slate-200 bg-white px-2 py-2"
      >
        <input
          type="text"
          className="h-8 flex-1 rounded-full border border-slate-200 px-3 text-[12px] outline-none focus:border-teal-500"
          placeholder="Ask a question."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          disabled={isSending}
        />
        <button
          type="submit"
          className="rounded-full bg-teal-600 px-3 py-1 text-[11px] font-semibold text-white hover:bg-teal-700 disabled:opacity-60"
          disabled={isSending}
        >
          Send
        </button>
      </form>
    </div>
  );
};

export default ChatWidget;
